import { Link } from '@tanstack/react-router';
import { settingsRoute, type SettingsTab } from '../../router.js';
import { CollectionsTab } from './collections-tab.js';
import { GeneralTab } from './general-tab.js';
import { HouseholdName } from './household-name.js';
import { HouseholdTab } from './household-tab.js';
import { SubscriptionTab } from './subscription-tab.js';

const TABS: { key: SettingsTab; label: string }[] = [
  { key: 'general', label: 'General' },
  { key: 'collections', label: 'Collections' },
  { key: 'household', label: 'Household' },
  { key: 'subscription', label: 'Subscription' },
];

export function Settings() {
  const { tab } = settingsRoute.useSearch();

  const current: SettingsTab = TABS.some((entry) => entry.key === tab)
    ? (tab ?? 'general')
    : 'general';

  return (
    <div className="tab-page">
      <header className="tab-page-head">
        <HouseholdName />
      </header>

      <nav className="tab-strip" aria-label="Settings sections">
        {TABS.map((entry) => (
          <Link
            key={entry.key}
            className="tab-link"
            to="/settings"
            // The default is left out of the URL, so /settings and ?tab=general are the
            // same page rather than two.
            search={entry.key === 'general' ? {} : { tab: entry.key }}
            // Every tab shares the /settings pathname, and an empty `search` is a subset
            // of every other search — so without exact matching the router marks every tab
            // active at once and underlines the lot.
            activeOptions={{ exact: true, includeSearch: true }}
          >
            {entry.label}
          </Link>
        ))}
      </nav>

      {current === 'general' && <GeneralTab />}
      {current === 'collections' && <CollectionsTab />}
      {current === 'household' && <HouseholdTab />}
      {current === 'subscription' && <SubscriptionTab />}
    </div>
  );
}
